<script>
    export default {
        props: {
            name: {
                type: String,
                required: true 
            },
            selected: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isActive: true
            };
        },
        computed: {
            href() {
                return '#' + this.name.toLowerCase().replace(/ /g, '-');
            }
        }
    }
</script>

<template>
    <div aria-role="tabpanel" v-show="isActive">
        <slot></slot>
    </div>
</template>

<style lang="less" scoped>

</style>
